export default __webpack_public_path__ + "static/media/preloader.ef0b785d.svg";